import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="w-full bg-cream pb-20 px-4 sm:px-6 lg:px-8" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-success/5 border-2 border-success/20 rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-71">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-success/10 rounded-full blur-3xl" data-id="element-72"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-73">
            <div className="bg-success text-white p-4 rounded-full mb-6 shadow-lg shadow-success/30" data-id="element-74">
              <ShieldCheck className="w-10 h-10" data-id="element-75" />
            </div>

            <h2 className="text-3xl font-heading font-black text-navy mb-4" data-id="element-76">
              Garantía de 7 días
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed mb-8 max-w-2xl" data-id="element-77">
              Si después de revisar el contenido sentís que no se ajusta a lo
              que necesitás para tus clases, devolvés la compra dentro de los 7
              días y te devolvemos el dinero. Sin vueltas.
            </p>

            <div className="inline-flex items-center gap-2 bg-success text-white font-bold px-5 py-2.5 rounded-full text-sm shadow-md" data-id="element-78">
              <ShieldCheck className="w-4 h-4" data-id="element-79" />7 días de protección al
              comprador
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}